<template>
  <div>
    <!-- 自动生成任务 -->
    <baseBreadcrumb :page="$t('message.autoGenerateTasks')" :menu="$t('message.spotCheck')" />
    <div class="body">
      <div class="tab">
        <div class="tabOpt" :class="{ act: datas.status === item.status }" v-for="(item, index) in listTab" :key="index"
          @click="search(item)">
          {{ item.name }}
          <span v-if="index > 0">({{ item.count }})</span>
        </div>
      </div>
      <div class="search">
        <div class="left">
          <div class="item">
            <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              range-separator="-" v-model="time" :default-time="['00:00:00', '23:59:59']"
              :start-placeholder="$t('message.startDate')" :end-placeholder="$t('message.dateClosed')" clearable>
            </el-date-picker>
          </div>
          <!--任务类型  -->
          <div class="item"> <el-select v-model="datas.type" :placeholder="$t('message.taskType')" clearable filterable>
              <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select></div>
          <!-- 是否历史售后 -->
          <!-- <div class="item">
            <el-select v-model="datas.has_after_sale" :placeholder="$t('message.historicalAfterSale')" clearable>
              <el-option :label="$t('message.are')" :value="1"></el-option>
              <el-option :label="$t('message.no')" :value="0"></el-option>
            </el-select>
          </div> -->
          <!--任务群体  -->
          <div class="item">
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <div class="item">
            <!-- 搜索 -->
            <el-button type="primary" @click="search({ status: datas.status })">{{ $t('message.search') }}</el-button>
            <el-button @click="reset">{{ $t('message.reset') }}</el-button>
          </div>
        </div>
        <div class="right">
          <!-- 创建任务 -->
          <el-button type="success" @click="createTask">{{ $t('message.createTask') }}</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 具体要求 -->
          <li class="flex2">{{ $t('message.specificRequirements') }}</li>
          <!-- 生效日期 -->
          <li class="flex15">{{ $t('message.effectiveDate') }}</li>
          <!-- 状态 -->
          <li>{{ $t('message.status') }}</li>
          <!-- 任务群体 -->
          <li>{{ $t('message.taskGroup') }}</li>
          <!-- 执行人-比例-未完成任务数 -->
          <li>{{ $t('message.executor') }}</li>
          <!-- 当前生成条件 -->
          <li class="flex2">{{ $t('message.currentGenerationConditions') }}</li>

          <!-- 操作 -->
          <li class="flex05">{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ item.rowNumber }}</li>
          <!-- 具体要求 -->
          <li class="flex2">
            <div class="template">
              <p> 任务类型：{{ item.type_name }} </p>
              具体要求：<span v-for="(desc, descIndex) in item.desc" :key="descIndex">({{ descIndex + 1 }}){{ desc }},</span>
            </div>
          </li>
          <!-- 生效日期 -->
          <li class="flex15">
            <div class="template">
              <p>开始:{{ item.start_at }}</p>
              <p>结束:{{ item.end_at }}</p>
            </div>
          </li>
          <!-- 状态 -->
          <li>
            <el-tag :type="item.status == 1 ? 'success' : 'info'">{{ item.status_name }}</el-tag>
          </li>
          <!-- 任务群体 -->
          <li>
            {{ item.organization.name }}
          </li>
          <!-- 执行人-比例-未完成任务数 -->
          <li>
            {{ item.execute_by_admin.realname }}
          </li>
          <!-- 当前生成条件 -->
          <li class="flex2">
            <div class="template">
              <p v-for="(ruleItem, spot_sparkIndex) in item.rule_str_arr" :key="spot_sparkIndex">
                {{ ruleItem }}
              </p>
            </div>
          </li>

          <!-- 操作 -->
          <li class="flex05">
            <router-link :to="'/autoTaskEditing?id=' + item.id" target="_blank">
              <el-button type="primary">{{ $t('message.redact') }}</el-button>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 请选择任务类型 -->
    <el-dialog :title="$t('message.pleaseSelectTaskType')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="380px" center>
      <div class="row">
        <div class="label"><span>*</span>{{ $t('message.taskType') }}:</div>
        <div class="val"><el-select v-model="taskType" :placeholder="$t('message.taskType')" clearable filterable>
            <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
            </el-option>
          </el-select></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 确定 -->
        <el-button type="primary" @click="createTaskType">
          {{ $t("message.ok") }}
        </el-button>
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      options: [],
      time: [],
      datas: {
        page: 1,
        pageSize: 20,
        type: "",
        start_at: "",
        end_at: "",
        org_id: '',
        has_after_sale: '',
        status: ''
      },
      options: [],
      tableData: [],
      total: 0,
      listTab: [],
      // 创建任务
      taskType: '',
      dialogVisible: false,
    };
  },
  created() {
    this.$api.spotCheckApi.spotTypeList().then(res => {
      this.options = res.data
    })
    this.$api.spotCheckApi.sparkListTab().then(res => {
      // res.data[2].status = 2
      this.listTab = res.data

    })
    this.sparkList()

  },
  methods: {
    // 配置列表tab
    sparkListTab() {

    },
    sparkList() {
      if (this.time != false) {
        this.datas.start_at = time[0];
        this.datas.end_at = time[1];
      } else {
        this.datas.start_at = '';
        this.datas.end_at = '';
      }
      this.$api.spotCheckApi.sparkList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    // 搜索
    search(item) {
      if (item) {
        this.datas.status = item.status
      }
      this.datas.page = 1;
      this.sparkList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 20,
        type: "",
        start_at: "",
        end_at: "",
        org_id: '',
        has_after_sale: '',
        status: ''

      };
      this.sparkList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.sparkList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.sparkList();
    },
    //
    setUserList(data) {
      this.datas.org_id = data.id;
    },
    //创建任务
    createTask() {
      this.taskType = ''
      this.dialogVisible = true
    },
    //创建任务类型
    createTaskType() {
      if (this.taskType == '') return this.$message.error('请选择任务类型')
      this.dialogVisible = false
      let url = this.$router.resolve({
        path: '/autoTaskEditing?type=' + this.taskType,
      });
      window.open(url.href, "_blank");
    },
  }
}
</script>
<style lang='scss' scoped>
.tab {
  display: flex;
  background: #F8F8F8;
  align-items: center;
  border-bottom: 1px solid #edeff4;
  margin-bottom: 20px;

  .tabOpt {
    height: 50px;
    min-width: 160px;
    padding: 0 30px;
    font-size: 18px;
    line-height: 50px;
    margin-bottom: -2px;
    box-sizing: border-box;
    text-align: center;
    border-top: solid 2px transparent;
    border-bottom: solid 2px transparent;
    cursor: pointer;


  }

  .act {
    color: #b4272d;
    border-top: solid 2px #b4272d;
    border-left: solid 1px #edeff4;
    border-right: solid 1px #edeff4;
    border-bottom: solid 2px #f8f8f8;
    background-color: #f8f8f8;
  }
}

.search {
  display: flex;
  justify-content: space-between;

  .left {
    display: flex;

    .item {
      margin-right: 20px;
    }
  }
}

.table {
  margin-top: 20px;

  ol {
    height: 50px;
  }

  ul {
    padding: 20px 0;
    background-color: #fff;
  }

  .flex05 {
    flex: 0.6;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }

  .template {
    width: 100%;

    p {
      line-height: 22px;
    }
  }
}

.row {
  display: flex;
  padding: 0 10px;

  .label {
    margin-right: 10px;
    line-height: 40px;

    span {
      color: red;
      margin-right: 5px;
    }
  }
}
</style>
